<script setup lang="ts">
import { computed } from 'vue';
import ImageAudioVideo from '../../bubble/ImageAudioVideo.vue';
import IconRightArrow from '../icons/IconRightArrow.vue';
// @ts-ignore
import { getInsiteOrigin } from 'shared/helpers/env';

import type { IGoodsMessage } from './types';

const props = defineProps<{ message: IGoodsMessage }>();

const {
  goodsId,
  goodsName,
  imageThumb,
  showOriginalPrice,
  showPromotePrice,
  country,
} = props?.message ?? {};

const attachment = {
  file_type: 'image',
  data_url: imageThumb,
  height: 123,
};

const handleClick = () => {
  window.open(`${getInsiteOrigin()}/details/${goodsId}`);
};

const showSecondaryPrice = computed(() => {
  return showOriginalPrice !== showPromotePrice;
});
</script>

<template>
  <div class="goods-card-root" @click="handleClick">
    <!-- <ImageAudioVideo :attachment="attachment" /> -->
    <img :src="imageThumb" height="123" />
    <div class="goods-card-content flex">
      <div class="goods-card-title">{{ goodsName }}</div>
      <div
        class="goods-card-price flex"
        :class="{ 'one-price': !showSecondaryPrice }"
      >
        <!-- 接口保证showPromotePrice一定存在，当不存在折扣价时，showPromotePrice和showOriginalPrice相同 -->
        <span class="main-price">{{ showPromotePrice }}</span>
        <span v-if="showSecondaryPrice" class="secondary-price">{{
          showOriginalPrice
        }}</span>
      </div>
    </div>
    <div class="goods-card-button">
      <IconRightArrow />
    </div>
  </div>
</template>

<style lang="scss">
.goods-card-root {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  cursor: pointer;
}

.card-message-card:has(.goods-card-content) {
  padding-inline-end: 4px !important;
  width: max-content;
  min-width: 300px;

  .card-body {
    display: flex;
    align-items: center;
    height: 123px;
  }
}

// 当卡片有日期时，按钮设置 padding-top，保证按钮图标在中间
.card-message-card:has(.card-date) {
  .goods-card-button {
    padding-block-start: 24px;
  }
}

.card-message-wrapper[dir='rtl'] {
  .goods-card-button svg {
    transform: rotate(180deg);
  }
}
</style>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.goods-card-content {
  margin-inline-start: 16px;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  height: calc(100% - 10px);
  font-size: 16px;

  .goods-card-title {
    width: 100%;
    color: #000;
  }

  .goods-card-price {
    gap: 8px;

    .main-price {
      font-size: 18px;
      color: #ff4800;
      font-weight: 600;
    }

    .secondary-price {
      color: #9d9d9d;
      text-decoration: line-through;
    }
  }

  .goods-card-price.one-price {
    .main-price {
      color: #000000;
    }
  }
}

.goods-card-button {
  height: 100%;
  width: 29px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
